import {IApiEndpoint, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import type {IProduto} from "@models/produtos/produto.ts";
import type {ICreateProdutoDto} from "@models/produtos/produtosDto.ts";
import {IProdutoFilters} from "@models/produtos/IProdutoFilters.tsx";
import {IDataDto} from "@models/shared/IDataDto.ts";
import {IGetProdutoFilters, ProdutoIncludable, ProdutoOrderable} from "@components/produtos/dto/IProdutosFilter.ts";
import {IOrder} from "@models/shared/IOrder.ts";

const v2prefix = '/api/v2/produtos';
export const __produto_endpoints = {
    getProdutosPesquisa: (search: string, pagination: IPagination): IApiEndpoint<IProduto> => ({
        url: '/api/Produtos/GetProdutosPesquisa',
        pagination: pagination,
        query: {search},
        method: "GET"
    }),
    createProduto: (produto: ICreateProdutoDto): IApiEndpoint => ({
        url: '/api/Produtos/CreateProduto',
        method: "POST",
        body: produto
    }),
    ['import-produtos']: (data: IDataDto<ICreateProdutoDto[]>): IApiEndpoint<IProduto[]> => ({
        url: '/api/Produtos/ImportProdutos',
        method: "POST",
        body: data,
    }),
    ['get-produtos']: ({filters, pagination}: {
        filters: IProdutoFilters,
        pagination: IPagination
    }): IApiEndpoint<IProduto[]> => ({
        url: '/api/Produtos/GetProdutos',
        method: "GET",
        query: filters,
        pagination: pagination
    }),
    ['v2']: {
        prefix: v2prefix,
        ['get-produtos']: (data: IDataDto<IGetProdutoFilters | undefined, ProdutoIncludable | undefined, IOrder<ProdutoOrderable> | undefined>): IApiEndpoint<IProduto[]> => ({
            url: `${v2prefix}`,
            method: "GET",
            data: data,
        })
    }
}

export const GetProdutos = (filters: IProdutoFilters, pagination: IPagination): IApiEndpoint<IProduto[]> => ({
    url: '/api/Produtos/GetProdutos',
    pagination: pagination,
    method: "GET",
    query: {
        id: filters.id,
        nome: filters.nome,
        idFornecedor: filters.idFornecedor,
        deveIncluir: filters.deveIncluir
    }
})

export default __produto_endpoints;